<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)" color="primary" class="text-none">
          <v-icon>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-card
          color="primary"
          flat
          tile
          :max-width="!$vuetify.breakpoint.mdAndDown ? '100%' : '100%'"
          :width="!$vuetify.breakpoint.mdAndDown ? '100%' : '100%'"
          :height="!$vuetify.breakpoint.mdAndDown ? '320': '100%'"
        >
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-img height="320" v-if="home.package" :src="home.package.image">
                <div
                  class="fill-height bottom-gradient d-flex align-end"
                  style="position: relative"
                >
                  <div
                    class="d-flex flex-column white--text pa-4"
                    v-if="home.location"
                  >
                    <div class="font-weight-medium text-h6">
                      {{ home.location.address }}
                    </div>
                    <div>{{ home.location.name }}</div>
                    <div class="font-weight-bold text-h5">
                      {{ formatMoney(home.homevestpackage.amount) }}
                    </div>
                  </div>
                </div>
              </v-img>
            </v-col>
            <v-col cols="12" md="8">
              <div class="py-4 px-10 text-justify fill-height">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-h6 font-weight-bold white--text mt-3">
                      {{ home.name }}
                    </div>
                    <v-card flat color="transparent" class="d-flex">
                      <div
                        class="text-caption font-weight-medium secondary--text"
                      >
                        Owner
                      </div>
                    </v-card>
                  </div>
                  <div class="text-center cursor-pointer">
                    <v-icon size="29" color="secondary">mdi-plus-circle</v-icon>
                    <div class="text-caption white--text">Top Up</div>
                  </div>
                </div>
                <div class="d-flex flex-column align-end mt-2">
                  <div class="white--text text-h7 font-weight-medium">
                        Balance
                      </div>
                      <div class="secondary--text text-caption">{{ formatMoney(home.total - home.totalpaid) }}</div>
                
                </div>
                <div class="mt-2">
                  <div class="d-flex justify-space-between">
                    <div>
                      <div class="white--text text-h7 font-weight-medium">
                        Amount Paid
                      </div>
                      <div class="success--text text-caption">
                        {{ formatMoney(home.totalpaid) }}
                      </div>
                    </div>

                    <div class="text-right">
                      <div class="white--text text-h7 font-weight-medium">
                        Total Amount
                      </div>
                      <div class="secondary--text text-caption">
                        {{ formatMoney(home.total) }}
                      </div>
                    </div>
                  </div>

                  <v-card
                    height="8px"
                    class="rounded-pill mt-2"
                    flat
                    width="100%"
                    color="white"
                  >
                    <v-card
                      height="8px"
                      flat
                      :width="`${(home.totalpaid / home.total) * 100}%`"
                      color="secondary"
                      class="rounded-pill"
                    ></v-card>
                  </v-card>

                  <div class="d-flex justify-space-between mt-4">
                    <div>
                      <div class="white--text text-h7 font-weight-medium">
                        Start Date
                      </div>
                      <div class="white--text text-caption">
                        {{ formatDate(home.startdate) }}
                      </div>
                    </div>

                    <div class="text-right">
                      <div class="white--text text-h7 font-weight-medium">
                        End Date
                      </div>
                      <div class="white--text text-caption">
                        {{ formatDate(home.enddate) }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mt-4">
                    <div>
                      <div class="white--text text-h7 font-weight-medium">
                        Next Charge Date
                      </div>
                      <div class="white--text text-caption">
                        {{ formatDate(home.nextpaymentdate) }}
                      </div>
                    </div>

                    <div class="text-right">
                      <div class="white--text text-h7 font-weight-medium">
                        Monthly Instalment
                      </div>
                      <div class="white--text text-caption" v-if="home.homevestpackage">
                        {{ formatMoney((home.total - home.totalpaid)/home.homevestpackage.duration) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" md="5">
        <v-row>
          <v-col cols="12" class="py-0 my-0">
            <div class="d-flex align-center">
              <div class="font-weight-medium text-h6">Actions</div>
              <v-card
                height="20"
                width="20"
                class="rounded-circle pa-1 d-flex align-center justify-center"
                flat
                color="secondary"
              >
                <v-icon color="primary" size="15">mdi-plus</v-icon>
              </v-card>
              <v-chip x-small>COMING SOON</v-chip>
            </div>
          </v-col>
          <v-col cols="6" md="6" v-for="(action, ix) in actions" :key="ix">
            <v-card flat color="#FFF9F2" height="150" max-height="200">
              <div
                class="d-flex justify-center align-center fill-height action-wrapper rounded-lg primary--border pa-3"
              >
                <div class="z-index-1 text-center">
                  <v-btn icon color="transparent">
                    <hm-icon height="43" width="47">
                      <plus-circle-icon />
                    </hm-icon>
                  </v-btn>
                  <div class="text-body-1 black--text font-weight-regular mt-2">
                    {{ action.title }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="7">
        <installments-table :instalments="home.instalments" />
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" md="5">
          <change-requests-table :changeRequests="home.requests"/>
      </v-col>
      <v-col cols="12" md="7">
          <special-requests-table :specialRequests="home.specialrequests"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UserService, TransactionService } from "@/services/index.js";
import { formatDate, formatMoney } from "@/utils/helpers";
// import HomesIcon from "@/components/icons/homes/HomesIcon.vue";
import HmIcon from "@/components/HmIcon.vue";
import PlusCircleIcon from "@/components/icons/PlusCircleIcon.vue";
import InstallmentsTable from "../../components/homes/InstallmentsTable.vue";
import ChangeRequestsTable from '../../components/homes/ChangeRequestsTable.vue';
import SpecialRequestsTable from '../../components/homes/SpecialRequestsTable.vue';

export default {
  components: {
    // HomesIcon,
    HmIcon,
    PlusCircleIcon,
    InstallmentsTable,
    ChangeRequestsTable,
    SpecialRequestsTable,
  },
  data() {
    return {
      pageTitle: "...",
      home: {},
      formatMoney,
      formatDate,
      //   LuxonDateTime: LuxonDateTime,
      activeInvestment: {},
      show: "pay",
      editingname: false,
      newname: "",
      activePayment: null,
      activeRequest: null,
      autodebit: "",
      paymenttype: "",
      actions: [
        {
          title: "Change Units",
          action() {},
        },
        {
          title: "Change Location",
          action() {},
        },
        {
          title: "Change Plan",
          action() {},
        },
        {
          title: "Special Request",
          action() {},
        },
      ],
    };
  },
  methods: {
    async toggleAutoDebit() {
      if (this.autodebit === "active") {
        this.autodebit = "paused";
      } else {
        this.autodebit = "active";
      }

      const { message } = await TransactionService.toggleAutoDebit(
        this.home.id
      );

      this.$store.commit("openSnackbar", {
        message,
      });
      this.loadHome;
    },
    async setPaymentType(paymenttype) {
      this.paymenttype = paymenttype;
      TransactionService.setPaymentType(this.home.id, paymenttype)
        .then((data) => {
          this.$store.commit("openSnackbar", data.message);
        })
        .finally(() => {
          this.loadHome();
        });
    },
    async loadHome() {
      this.editingname = false;
      const { id } = this.$route.params || this.$route.query;
      const home = await UserService.getSub(id);
      this.home = home.data;
    //   console.log(this.home);
      this.home.instalments = this.home.instalments.reverse();
      this.autodebit = this.home.recurringpayment.status;
      this.paymenttype = this.home.recurringpayment.paymenttype;
      this.pageTitle = this.home.package.packagename;
      this.newname = this.home.name;
    },
    changeName() {
      if (this.home.name) {
        if (this.newname.toLowerCase() == this.home.name.toLowerCase()) {
          this.$store.commit("openSnackbar", `No changes were made`);

          this.editingname = !this.editingname;
          return;
        }
      }

      //   this.$bvModal.show("change-name-modal");
    },
    setActiveTab() {
      //   this.$bvModal.hide("investment-details-modal");
      this.home = null;
      this.loadHome();
    },
    handleClicked(show) {
      this.show = show;
      //   this.$bvModal.show("investment-details-modal");
    },
    paymentDetails(payment) {
      this.activePayment = payment;
      //   this.$bvModal.show("payment-details");
    },
    changeRequestDetails(request) {
      this.activeRequest = request;
      //   this.$bvModal.show("change-request-details");
    },
  },
  mounted() {
    this.loadHome();
  },
};
</script>

<style lang="scss" scoped>
.action-wrapper {
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04) !important;
}
</style>
